export const removeDoubleSlash = url => {
    return url.replace(/\/\//g, "/")
  }
  